import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { exportAtributeThunk, getAllAtributesThunk, setAtributePage, setAtributeRefresh } from '../../../redux/atributes/getAllAtributes';
import MasterHeader from '../../../component/reusable/MasterHeader';
import { toast } from 'react-toastify';
import api from '../../../utils/api';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';
import VariantsTable from '../../../component/attributesComps/VariantsTable';


const Variants = () => {



  const { atributes, loading, error, refresh, exportLoading, page } = useSelector((state) => state.atributes);
  const [search, setSearch] = useState('')
  const dispatch = useDispatch()
  const navigate = useNavigate()


  const [statuss, setStatus] = useState("");
  const [limit, setLimit] = useState(25)
  const [sortBy, setSortyBy] = useState('createdAt');
  const [order, setOrder] = useState('asc')

  const atribute = atributes?.data
  const totalPages = atributes?.totalPages
  const totalItems = atributes?.totalItems
  const itemsPerPage = atributes?.limit

  // calculate start & end of items -------------------
  const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;




  useEffect(() => {
    dispatch(getAllAtributesThunk(`?search=${search}&page=${page}&status=${statuss}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
  }, [page, search, statuss, limit, refresh, sortBy, order]);



  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();

      formData.append('file', file);

      const response = await api.addBulkAtribute(formData);
      if (response.data) {

        toast.success(response?.data?.data?.message)
        dispatch(setAtributeRefresh());
      }
    } catch (err) {
      console.log("atribute error", err);
      toast.error(err?.response?.data?.message || 'Something went wrong')
    }
  };



  const exportData = async () => {
    const data = await dispatch(exportAtributeThunk())

    if (data?.payload?.success === true) {
      const subcategoriesdata = data?.payload?.data
      const exportdata = subcategoriesdata?.map((item) => ({
        'variant_name': item?.variant_name || '',
        'status': item?.status,
        'createdAt': fomateDate(item?.createdAt),

      }))
      exportDataExcel(exportdata, "atributes")
    }
  }

  const handleOpenMenu = (sort) => {
    setSortyBy(sort)
    setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };


  return (
    <div >


      <MasterHeader
        index="Variants"
        root="Dashboard"
        setStatus={setStatus}
        setSearch={setSearch}
        handleFileChange={handleFileChange}
        onClickadd={() => navigate('/master/addVariants')}
        buttonText={'Add Variants'}
        exportData={exportData}
        exportLoading={exportLoading}
      />



      {loading ?
        <div>
          Please wait...
        </div>
        :
        <>
          {
            atribute?.length > 0 ?
              <VariantsTable
                atributes={atribute}
                itemsPerPage={itemsPerPage}
                start={start}
                end={end}
                setPage={setAtributePage}
                totalItems={totalItems}
                page={page}
                handleOpenMenu={handleOpenMenu}
              />
              :
              <div>
                No atributes found
              </div>

          }
        </>
      }

    </div>
  );
};

export default Variants;
